import requireAll from './requireAll';

// Note: This regex matches all files that end in *.js or *.ts but not *.spec.js or *.spec.ts:
//
// /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/
//
// I don't think it can be simplified without look behinds (coming in ESNext), but I challenge you to try!
// Your new regex should match all *.js and *.ts files but not *.spec.js or *.spec.ts files in this
// (non-exhaustive) list:
//
// ./src/app/core/app.jwtIntConfig.spec.js
// ./src/app/core/app.jwtIntConfig.js
// ./t/a.js
// ./ab.js
// ./abc.js
// ./abcd.js

// Include these imports here instead of in vendor.js because they will be imported anyway with `import` statements
// elsewhere in the app.
window._ = require('lodash');

// TLDR: moment-recur gets a reference to moment, does its thing and returns moment.
// I don't like the way recur encapsualtes the use of moment but we have to deal with it for now. 
// In pre npm days, we had to attach moment to window. When we moved moment-recur form bower, due to the way 
// moment-recur works, the instance of moment it returns isn't the same as the one we attached to window.
// since the package was modified, it makes sense to avoid npm.
window.moment = require('moment-recur');

import './core';
requireAll(require.context('./features', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./layout', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./routes', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
import './sdc';
import './shared';
requireAll(require.context('./student', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));

// Require all app SASS
requireAll(require.context('./', true, /\.scss$/));
